import React, { useEffect, useState, useRef } from "react";
import { Search, PawPrint } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Avatar } from "../Avatar";
import { api } from "../../lib/api";
import { formatDateTime } from "../../lib/ranks";

export function VisitorsBell({ open, onToggle, onClose }) {
  const navigate = useNavigate();
  const [visitors, setVisitors] = useState(null);
  const rootRef = useRef(null);

  useEffect(() => {
    if (open) api.get("/profile/visitors").then((r) => setVisitors(r.data.visitors || [])).catch(() => setVisitors([]));
  }, [open]);

  // Close the panel when clicking anywhere outside the bell + its dropdown.
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open, onClose]);

  return (
    <div className="relative" ref={rootRef}>
      <button data-testid="visitors-bell" onClick={onToggle} title="Who visited your den"
        className={`p-2 rounded-full hover:bg-slate-800/70 transition-colors ${open ? "text-sky-400" : "text-slate-300 hover:text-sky-400"}`}>
        <Search className="w-5 h-5" />
      </button>
      {open && (
        <div className="fixed top-[calc(4rem+var(--hdr-top))] left-2 right-2 ml-auto max-w-sm max-h-[calc(100vh-5.5rem-var(--hdr-top))] overflow-y-auto no-scrollbar z-50 bg-[#0d141e] border border-slate-700 rounded-xl shadow-2xl animate-slide-up sm:absolute sm:top-auto sm:left-auto sm:right-0 sm:mt-2 sm:w-80 sm:max-w-none sm:max-h-[70vh]" data-testid="visitors-dropdown">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-800 sticky top-0 bg-[#0d141e] z-10">
            <Search className="w-4 h-4 text-sky-400" />
            <span className="font-display text-sm text-slate-200">Who prowled your den</span>
          </div>
          {visitors === null ? (
            <div className="px-4 py-6 text-center text-slate-500 text-sm">Peering into the mist…</div>
          ) : visitors.length === 0 ? (
            <div className="px-4 py-8 text-center text-slate-500 text-sm"><PawPrint className="w-8 h-8 mx-auto mb-2 text-slate-700" />No visitors yet.</div>
          ) : (
            visitors.map((v) => (
              <button key={v.user.id} data-testid={`visitor-item-${v.user.id}`}
                onClick={() => { onClose(); navigate(`/w/${v.user.username}`); }}
                className="w-full flex items-center gap-3 px-4 py-3 text-left border-b border-slate-800/50 hover:bg-slate-800/40 transition-colors">
                <Avatar user={v.user} size="sm" ring={false} />
                <div className="min-w-0 flex-1">
                  <div className="text-sm text-slate-200 truncate">{v.user.name}</div>
                  <div className="text-[11px] text-slate-500">{formatDateTime(v.last_at)}</div>
                </div>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
